import React from "react";

const PhoneIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64.442"
    viewBox="0 0 64.442 90.01"
    clipRule="evenodd"
    fillRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    {...props}
  >
    <path
      fill={props.color}
      d="M48.563 89.74c7.62 2.42 15.831-12.205 15.879-14.655.082-4.18-12.79-17.117-14.674-16.105-2.966 1.592-11.672 4.517-13.191 4.091-5.587-1.566-20.098-26.7-18.66-32.322.39-1.527 7.276-7.605 10.137-9.377 1.82-1.127-2.948-18.742-6.61-20.761C19.298-.573 2.528-.775.813 7.035-5.1 33.949 22.3 81.403 48.563 89.74z"
    />
  </svg>
);
export default PhoneIcon;
